import React from 'react';
import { usePlanTotalContext } from 'plans/plan/context';

export const UtilizationFooter: React.FC = () => {
  const { utilization } = usePlanTotalContext();

  return <>{utilization.toFixed(2)}&nbsp;%</>;
};
